module.exports = __webpack_public_path__ + "static/media/fakeeh.0e0e2fbe.jpg";